import store from '../../store'


export function handleMeetingArchivedPusher(meetingId) {
	store.dispatch({ type: 'ARCHIVE_MEETING_SUCCESS', meetingId})
}